/**
 * @generated SignedSource<<c1093bcdbe8a0213bfff539dbd23c487>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_relatedWorkEdges">;
  readonly " $fragmentType": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges";
}>;
export type async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges$key = ReadonlyArray<{
  readonly " $data"?: async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges$data;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_relatedWorkEdges"
    }
  ],
  "type": "JiraVersionRelatedWorkV2Edge"
};

(node as any).hash = "a1ee6f3b568b757ef42ae7c9484cb878";

export default node;
